module.exports = __webpack_public_path__ + "assets/img/product-bg.1483bfc3.png";